import React from "react";

export function PageHeader({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative overflow-hidden bg-[var(--bcol-navy)] text-white">
      {image && <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />}
      <div className="absolute inset-0 bg-gradient-to-b from-[var(--bcol-navy)]/95 via-[var(--bcol-navy)]/85 to-[var(--bcol-navy)]" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-24 lg:py-32">
        <div className="flex items-center gap-3 mb-5">
          <div className="kente-line" />
          {eyebrow && <span className="eyebrow text-[var(--bcol-gold)]">{eyebrow}</span>}
        </div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-5 text-lg text-white/80 max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
}

export function Section({ children, className = "" }) {
  return <section className={`section-pad ${className}`}><div className="max-w-7xl mx-auto px-5 lg:px-8">{children}</div></section>;
}

export function Field({ label, children, testid }) {
  return (
    <label className="block" data-testid={testid && `${testid}-wrap`}>
      <span className="text-xs uppercase tracking-[0.18em] text-[var(--bcol-muted)] font-semibold mb-2 inline-block">{label}</span>
      {children}
    </label>
  );
}

export function Input(props) {
  return <input {...props} className={`w-full bg-white border border-[var(--bcol-border)] rounded-xl px-4 py-3 text-[var(--bcol-text)] focus:outline-none focus:border-[var(--bcol-navy)] transition ${props.className || ""}`} />;
}

export function Textarea(props) {
  return <textarea {...props} className={`w-full bg-white border border-[var(--bcol-border)] rounded-xl px-4 py-3 text-[var(--bcol-text)] focus:outline-none focus:border-[var(--bcol-navy)] transition ${props.className || ""}`} />;
}
